export const BRILLIANT_PAD_DICT = {
  BASIC: {
    key: 'BASIC',
    getDescription: () => 'Replaces pad with the press of a button.',
    price: 22900,
    originalPrice: 27900,
    image: '/brilliant-pad-basic.png',
  },
  SMART: {
    key: 'SMART',
    getDescription: (name) =>
      `See what ${name} left behind and clean from your smart phone. Use PoopAI™ to detect when puppy may be sick.`,
    price: 29900,
    originalPrice: 34900,
    image: '/brilliant-pad-smart.png',
  },
}
